/**
 * Text to use that represents content from Khan Academy's lesson content.
 * This allows us to test different screens with actual titles of domains,
 * subjects, units, lessons, and content items from the product.
 * This data represents a small fraction of the content that was in the product
 * at the time that this file was created and if not representative of the full
 * range of text on the site at this point in time.
 *
 * These lists of data are often used with `randomElementFromArray` or
 * `randomElementsFromArray` to allow us to test many different types of strings
 * on each screen.
 */
const ContentData = {};
ContentData.Domains = [
    "Math by subject",
    "Math by grade",
    "Science & engineering",
    "Computing",
    "Arts & humanities",
    "Economics & finance",
    "Test prep",
    "College, careers, & more",
];
ContentData.Subjects = [
    "Physics",
    "AP Physics 1",
    "AP Physics 2",
    "Cosmology & astronomy",
    "Chemistry",
    "AP Chemistry",
    "Organic chemistry",
    "Biology",
    "AP Biology",
    "Health & medicine",
    "Electrical engineering",
];
ContentData.Units = [
    "Atoms, compounds, and ions",
    "Stoichiometry and molecular composition",
    "Chemical reactions",
    "Electronic structure of atoms",
    "Periodic table",
    "Chemical bonds",
    "States of matter and intermolecular forces",
    "Gases and kinetic molecular theory",
    "Kinetics",
    "Thermodynamics",
    "Chemical equilibrium",
    "Acids and bases",
    "Buffers, titrations, and solubility equilibria",
    "Redox reactions and electrochemistry",
    "Studying for the AP Chemistry exam?",
];
ContentData.Lessons = [
    "Oxidation-reduction reactions",
    "Galvanic cells",
    "Standard cell potentials",
    "Electrochemistry, thermodynamics, and equilibrium",
    "Cell potentials under nonstandard conditions",
    "Electrolytic cells and electrolysis",
];
ContentData.Content = [
    "Oxidation and reduction",
    "Oxidation state trends in periodic table",
    "Practice determining oxidation states",
    "Unusual oxygen oxidation states",
    "Oxidation-reduction (redox) reactions",
    "Introduction to redox reactions",
    "Redox reaction with iron",
    "Oxidizing and reducing agents",
    "Disproportionation",
    "Balancing redox reactions in acid",
    "Balancing redox reactions in base",
    "Redox titration",
    "Redox reaction from dissolving zinc in copper sulfate",
    "Introduction to galvanic/voltaic cells",
    "Electrodes and voltage of Galvanic cell",
    "Shorthand notation for galvanic/voltaic cells",
    "Lead storage battery",
    "Nickel-cadmium battery",
    "2015 AP Chemistry free response 1d",
    "Standard reduction potentials",
    "Using reduction potentials",
    "Voltage as an intensive property",
    "Spontaneity and redox reactions",
    "2015 AP Chemistry free response 1a",
    "Free energy and cell potential",
    "Standard cell potential and the equilibrium constant",
    "Calculating the equilibrium constant from the standard cell potential",
    "Galvanic cells and changes in free energy",
    "Nernst equation",
    "Using the Nernst equation",
    "Concentration cell",
    "2015 AP Chemistry free response 1b and c",
    "Introduction to electrolysis",
    "Quantitative electrolysis",
    "Electrolysis of molten sodium chloride",
];

// Testing code. TODO: Remove this stuff
ContentData.DummyText = {
    XXLarge: "Science and Engineering",
    XLarge: "The hydrologic and carbon cycles: Always recycle!",
    Large: "European Middle Ages: feudalism and serfdom",
    Medium: "The closest Europe came to operating under one system of landowner agreements was in the late eighth and early ninth century CE. Charlemagne established counties and appointed counts to rule regions of his domain. But, in the wake of his death, his empire dissolved. Counts who had received lands from the court of Charlemagne began to consolidate their own local power, exerting control over the people who lived on their lands.",
    Small: "They owed allegiance to the Church and to the kingdoms that guaranteed their claims of land ownership, but each medieval lord established their own particular set of rules. If you were to travel through early medieval Europe, you would find yourself in a hundred petty kingdoms, each with its own manor or landed estate, each one with its manorial court. The land of these manors was tilled by unfree agricultural workers, or serfs. To discover exactly what a serf is, we'll need to move back in history a bit and visit late Imperial Rome.",
    XSmall: "By clicking “Create accounts”, you indicate that you have the parent’s permission to create this account and agree to our Terms of Service and Privacy Policy.",
    //
    Title: "You can learn anything.",
    Tagline: "For free. For everyone. Forever.",
    HeadingLarge: "Science and Engineering",
    HeadingMedium: "The hydrologic and carbon cycles",
    HeadingSmall: "European Middle Ages: feudalism and serfdom",
    Body: "The closest Europe came to operating under one system of landowner agreements was in the late eighth and early ninth century CE. Charlemagne established counties and appointed counts to rule regions of his domain. But, in the wake of his death, his empire dissolved. Counts who had received lands from the court of Charlemagne began to consolidate their own local power, exerting control over the people who lived on their lands.",
    BodySerif: "The closest Europe came to operating under one system of landowner agreements was in the late eighth and early ninth century CE. Charlemagne established counties and appointed counts to rule regions of his domain. But, in the wake of his death, his empire dissolved. Counts who had received lands from the court of Charlemagne began to consolidate their own local power, exerting control over the people who lived on their lands.",
    BodyMonospace: "int main(int argc, char *argv[]) { return 0; }",
    Caption: "They owed allegiance to the Church and to the kingdoms that guaranteed their claims of land ownership, but each medieval lord established their own particular set of rules. If you were to travel through early medieval Europe, you would find yourself in a hundred petty kingdoms, each with its own manor or landed estate, each one with its manorial court. The land of these manors was tilled by unfree agricultural workers, or serfs. To discover exactly what a serf is, we'll need to move back in history a bit and visit late Imperial Rome.",
    Footnote: "Your parent or guardian must approve your account or it will be deleted in 7 days.",
    UIBody: "By clicking “Create accounts”, you indicate that you have the parent’s permission to create this account and agree to our Terms of Service and Privacy Policy.",
    LabelMedium: "Displaying and comparing quantitative data",
    LabelSmall: "Displaying and comparing quantitative data",
};

export default ContentData;



// WEBPACK FOOTER //
// ./src/core/ContentData.js